import LogisticsSection from './LogisticsSection';

export default LogisticsSection;
